import React from 'react';
import { Monitor, Smartphone } from 'lucide-react';
import { cn } from '../../utils/cn';
import { useLayoutVariant } from '../../hooks/useLayoutVariant';

interface StreamerModeToggleProps {
  className?: string;
}

export const StreamerModeToggle: React.FC<StreamerModeToggleProps> = ({ className }) => {
  const { isStreamerMode, toggleStreamerMode } = useLayoutVariant();

  // When streamer mode is ON, we're showing compact layout
  const isMobileView = isStreamerMode;

  return (
    <button
      type="button"
      onClick={toggleStreamerMode}
      className={cn(
        'relative inline-flex items-center',
        'w-12 h-6 p-0.5 rounded-full',
        'bg-gray-200 dark:bg-gray-700',
        'transition-colors duration-300',
        'focus:outline-none focus:ring-2 focus:ring-offset-2',
        'focus:ring-gray-400 dark:focus:ring-gray-500',
        'focus:ring-offset-white dark:focus:ring-offset-gray-900',
        className
      )}
      aria-label={`Switch to ${isMobileView ? 'desktop' : 'mobile'} view`}
      title={`Switch to ${isMobileView ? 'desktop' : 'mobile'} view`}
      role="switch"
      aria-checked={isMobileView}
    >
      {/* Sliding knob */}
      <span
        className={cn(
          'absolute w-5 h-5 rounded-full',
          'bg-white shadow-md flex items-center justify-center',
          'transition-transform duration-300 ease-in-out',
          isMobileView ? 'translate-x-6' : 'translate-x-0'
        )}
        style={{ left: '2px' }}
        aria-hidden="true"
      >
        <Monitor
          className={cn(
            'absolute transition-all duration-200',
            'w-3 h-3',
            isMobileView ? 'opacity-0 scale-75' : 'opacity-100 scale-100 text-blue-600 dark:text-blue-400'
          )}
          aria-hidden="true"
        />
        <Smartphone
          className={cn(
            'absolute transition-all duration-200',
            'w-3 h-3',
            isMobileView ? 'opacity-100 scale-100 text-emerald-600 dark:text-emerald-400' : 'opacity-0 scale-75'
          )}
          aria-hidden="true"
        />
      </span>
    </button>
  );
};

export default StreamerModeToggle;
